// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import axios from "axios";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";
import StyledSelect from "./styledSelect";
import Select from "react-select";
import { AssetType } from "../../../../models/applicationState";
import { getPrimaryRedTheme } from "../../../../common/themes";
import { Spinner, SpinnerSize } from "office-ui-fabric-react";
import Confirm from "../../common/confirm/confirm";
import ServiceHelper from "../../../../services/serviceHelper";
import OperationsHeader from "../header/operationsSubHeader";
import JsonViewer from "../testUploadFiles/jsonResponse";
import ReactJson from "react-json-view";
import { IAzureFields } from "../../../../models/applicationState";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import { constants } from "../../../../common/constants";
import { processedFileEndPoint, LoadUserFilesEndPointBasedOnModel, headers, fileUploadEndPoint, accessToken } from "../../../../common/api-config";
import { parseTiffData, renderTiffToCanvas, loadImageToCanvas } from "../../../../common/utils";
import { ImageMap } from "../../common/imageMap/imageMap";
import HeaderComponent from "../header/header";
import { IAuthenticationState, IApplicationState } from "../../../../models/applicationState";
import HtmlFileReader from "../../../../common/htmlFileReader";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
//import pdfjsLib from "pdfjs-dist";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import Fill from "ol/style/Fill";

const cMapUrl = constants.pdfjsCMapUrl(pdfjsLib.version);

export interface IBatchProcessProps extends RouteComponentProps, React.Props<BatchProcess> {
    loggedInUser: IAuthenticationState;
    userModelActions: IUserModelActions;
    userOperationsActions: IUserOperationsActions;
}

function mapDispatchToProps(dispatch) {
    return {
        userModelActions: bindActionCreators(userModelActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
    };
}

export interface IBatchProcessState {
    batchProcess: any;
    loadingProjects: boolean;
    loadingQueueFiles: boolean;
    projectList: any;
    selectedQueue: any;
    filesList: any;
    loaderMessage: string;
    errorMessage: any;
    fileNames: any;
    batchProcessFlag: boolean;
    selectedProject: any;
    analyzeResult: any;
    projectName: string;
    loadingQueues: boolean;
    queuesList: any;
    loadingJson: boolean;
    queueName: string;
    fileName: string;
    imageUri: string;
    imageWidth: number;
    imageHeight: number;
    currentPage: number;
    numPages: number;
    pdfFile: any;
    loadingFile: boolean;
    tiffImages: any[];
    isEditJson: boolean,
    changedJSON: any,
    isBool: boolean,
    expandString: boolean;
    errorList: any;
    errFiles: any;
    healthQueueList: any;
}

function mapStateToProps(state: IApplicationState) {
    return {
        loggedInUser: state.loggedInUser,
    };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class BatchProcess

    extends React.Component<IBatchProcessProps, IBatchProcessState> {

    public static getDerivedStateFromProps(nextProps, prevState) {
        const state = Object.assign({}, prevState);
        if (!state.projectName) {
            // state.projectName = localStorage.getItem("project_name");
            // state.queueName = localStorage.getItem("queue_name");
        }
        return state;
    }

    public state: IBatchProcessState = {
        batchProcess: {},
        projectName: "Health-queue",
        projectList: [],
        filesList: [],
        analyzeResult: null,
        errorMessage: null,
        fileNames: [],
        loadingJson: false,
        batchProcessFlag: false,
        loadingQueues: false,
        selectedProject: null,
        loaderMessage: "Loading Models",
        queuesList: [],
        selectedQueue: null,
        queueName: "",
        loadingProjects: false,
        loadingQueueFiles: false,
        fileName: "",
        imageUri: null,
        imageWidth: 0,
        currentPage: 1,
        numPages: 1,
        pdfFile: null,
        loadingFile: false,
        // outPutFormat: "",
        imageHeight: 0,
        tiffImages: [],
        isEditJson: false,
        changedJSON: [],
        isBool: true,
        expandString: false,
        errorList: [],
        errFiles: [],
        healthQueueList: [
            /*{
            date: "2020-06-24 07:40:15.406836", description: "test", files: "3",
            project_name: "Health-queue", queue_name: "HC", title: "Health Certificates"
        },*/
        {
            date: "2020-06-24 07:40:15.406836", description: "test", files: "5",
            project_name: "Health-queue", queue_name: "PO", title: "Purchase Orders "
        },
        {
            date: "2020-06-24 07:40:15.406836", description: "test", files: "2",
            project_name: "Health-queue", queue_name: "INV", title: "Invoices"
        },
        ],
    };

    private deleteFileConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    /** shoe test Image */
    private currPdf: any;
    private tiffImages: any[];
    private imageMap: ImageMap;
    private timeInterval: any;
    public async componentDidMount() {
        this.getProjects();
    }

    public featureStyler = (feature) => {
        const regionId = feature.get("id");
        return new Style({
            stroke: new Stroke({
                color: "#fffc7f",
                width: 1,
            }),
            fill: new Fill({
                color: "rgba(255, 252, 127, 0.2)",
            }),
        });
    }

    public noOp = () => {
        // no operation
    }

    public handleChange = v => {
        let allData = this.state.analyzeResult
        allData[0].dcapResults = v.updated_src[0]
        allData[0].transformationResults = v.updated_src[1]
        this.setState({ changedJSON: allData });
    };

    public errFileShow = () => {
        return (
            <div>
                {this.state.errorList.length > 0 ?
                    <table className="table table-bordered table-dark">
                        <thead>
                            <tr>
                                <th scope="col" className="s-no">#</th>
                                <th scope="col" className="f-name">File name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.errorList.map((file, index) => {
                                const fileName = file.filename;
                                return (
                                    <tr key={index}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{fileName}</td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    : <p className="text-white text-center mt-3">No Data Available</p>
                }
            </div>
        )
    }
    public viewJSONFun = () => {
        if (this.state.analyzeResult && this.state.isEditJson === false) {
            return (
                <div>
                    {this.state.analyzeResult && this.state.isEditJson === false &&
                        <JsonViewer
                            history={this.props.history}
                            match={this.props.match}
                            location={this.props.location}
                            outPutFormat="Transform"
                            export={true}
                            jsonData={this.state.analyzeResult}
                        />
                    }
                </div>
            )
        } else if (this.state.analyzeResult && this.state.isEditJson === true) {
            let transform = this.state.analyzeResult[0].transformationResults
            let dcapResults = [];
            if (transform === undefined) {
                dcapResults.push(this.state.analyzeResult[0].dcapResults)
            } else {
                dcapResults.push(this.state.analyzeResult[0].dcapResults, transform)
            }
            return (
                <div>
                    {/* <h2>Show editable json</h2> */}
                    {this.state.analyzeResult ?
                        <ReactJson theme="bright"
                            iconStyle="square"
                            collapsed={true}
                            onEdit={e => this.handleChange(e)}
                            onDelete={e => this.handleChange(e)}
                            onAdd={e => this.handleChange(e)}
                            src={dcapResults}
                        /> : <div>No Data Available</div>}
                </div>
            )
        }
        else {
            return (
                <div />
            )
        }

    }
    public render() {
        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />
                <LoadingOverlay
                    active={this.state.loadingQueues || this.state.loadingProjects}
                    spinner
                    className={this.state.loadingQueues || this.state.loadingProjects ? "wrap-queue-height" : ""}
                    text={this.state.loaderMessage}
                >
                    <OperationsHeader propsMatch={this.props.match} />
                    {this.state.loadingProjects &&
                        <div className="text-center">
                            <Spinner
                                label={this.state.loaderMessage}
                                ariaLive="assertive"
                                className="mt-5"
                                labelPosition="bottom"
                                size={SpinnerSize.large}
                            />
                        </div>
                    }
                    {!this.state.loadingProjects &&
                        <>
                            <div className={this.state.expandString ? "expand-jsn" : "hide"}>
                                <div className="jsn-block">
                                    <div className="preview_json">
                                        <button type="button" className="btn-max-min expand" onClick={() => this.getExpandButton(false)} data-toggle="collapse" data-target="#demo" aria-expanded="true"><i className="fa fa-compress"></i> </button>
                                        {this.viewJSONFun()}
                                        {!this.state.loadingJson && !this.state.analyzeResult && !this.state.errorMessage &&
                                            <span>Select file</span>
                                        }
                                        {this.state.errorMessage && this.state.errorMessage
                                            && <p className="text-center mt-5">{this.state.errorMessage}</p>}
                                        {this.state.loadingJson
                                            && <Spinner
                                                label="Loading JSON"
                                                ariaLive="off"
                                                className="loading" size={SpinnerSize.large} />}

                                    </div>
                                </div>

                            </div>
                            <div className="container-fluid">
                                <div className="row mt-1">
                                    <div className="col-3">
                                        <label className="mb-0">Select Queue:</label>
                                        <Select
                                            value={this.state.selectedProject}
                                            getOptionLabel={(option) =>
                                                `${option.project_name}`
                                            }
                                            placeholder="Select Model"
                                            className="react-select-container zindex-20"
                                            getOptionValue={(option) => `${option.project_name}`}
                                            onChange={this.onChange}
                                            options={this.state.projectList}
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: "#161a1f",
                                                    primary: "#6b727d",
                                                    neutral0: "#2a2f35",
                                                    neutral20: "#44474c",
                                                    neutral30: "#272c33",
                                                    neutral50: "#fff",
                                                    neutral80: "#9da7b5",
                                                },
                                            })}
                                        />
                                    </div>
                                    <div className="col-2">
                                        {/* <label className="mb-0">Select Queue:</label> */}
                                        <label className="mb-0">Select Date:</label>
                                        <div>
                                            {/* <DatePicker selected={new Date()} onChange={this.handleSelect} /> */}
                                            <input type="text" className="form-control date-period" placeholder="Oct 2020" color="white" />
                                        </div>
                                        {/* <Select
                                            value={this.state.selectedQueue}
                                            getOptionLabel={(option) =>
                                                `${option.queue_name}`
                                            }
                                            placeholder="Select Queue"
                                            className="react-select-container zindex-20"
                                            getOptionValue={(option) => `${option.queue_name}`}
                                            onChange={this.onQueueChange}
                                            options={this.state.queuesList}
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: "#161a1f",
                                                    primary: "#6b727d",
                                                    neutral0: "#2a2f35",
                                                    neutral20: "#44474c",
                                                    neutral30: "#272c33",
                                                    neutral50: "#fff",
                                                    neutral80: "#9da7b5",
                                                },
                                            })}
                                        /> */}
                                    </div>
                                    <div className="col-3">
                                        {/* {!this.state.loadingQueues && this.state.queuesList.length === 0 &&
                                            <Link to="/operations/queues" className="btn-custom text-dark"> Start Queue </Link>
                                        } */}
                                        {/* <label className={this.state.queueName ? "btn-custom import-btn text-dark" : "btn-custom disabled-label text-dark"}>
                                            Import
                                    <input disabled={this.state.queueName ? false : true} type="file" accept="image/*, application/pdf" multiple onChange={this.onChangeHandler} />
                                        </label> */}
                                        <button className="btn-custom import-btn" onClick={this.getAllFiles}>
                                            <i className="fas fa-sync-alt"></i>  Refresh
                                    </button>
                                    </div>

                                    {/* <div className="col-4 export-json">
                                        {this.state.analyzeResult ?
                                            <button onClick={this.downloadFile}
                                                disabled={this.state.filesList.length > 0 ? false : true} className="btn-custom process-btn Extract-btn float-right"> Export JSON </button>
                                            : <div></div>
                                        }

                                        {this.state.isEditJson ?
                                            <div>
                                                <button onClick={this.editableJSONView}
                                                    disabled={this.state.filesList.length > 0 ? false : true} className="btn-custom process-btn Extract-btn float-right"> Submit JSON </button>
                                                <button onClick={this.cancelJsonButtonClick}
                                                    disabled={this.state.filesList.length > 0 ? false : true} className="btn-custom process-btn Extract-btn float-right"> Cancel </button>

                                            </div>
                                            : <div></div>
                                        }

                                        {this.state.analyzeResult && this.state.isEditJson == false ?
                                            <button onClick={this.editableJSON}
                                                disabled={this.state.filesList.length > 0 ? false : true} className="btn-custom process-btn Extract-btn float-right"> Edit JSON </button>
                                            : <div></div>
                                        }

                                        {!this.state.batchProcessFlag ?
                                            <button onClick={this.processBatch}
                                                disabled={this.state.filesList.length > 0 ? false : true} className="btn-custom process-btn Extract-btn float-right"> Process All Files </button>
                                            : <Spinner className="custom-loading" label="Processing Batch" size={SpinnerSize.small} />
                                        }
                                    </div> */}

                                </div>
                            </div>
                            <div className="batch-process">
                                <div className="col br-r-1">
                                    <section id="tabs">
                                        <div className="text-uppercase mt-2 text-white">Queues List</div>
                                        {this.state.healthQueueList && this.state.healthQueueList.length > 0 &&
                                            <table className="table table-bordered table-hover table-dark">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className="s-no">#</th>
                                                        <th scope="col" className="f-name">Queue name</th>
                                                        <th scope="col" className="date"  >Description</th>
                                                        <th scope="col" className="Action">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.healthQueueList.map((queue, index) => {

                                                        return (
                                                            <tr className={index == 0 ? "active-tr" : ""} key={index}>
                                                                <th scope="row">{index + 1}</th>
                                                                <td title={queue.title}>{queue.queue_name}</td>
                                                                <td>{queue.title}</td>
                                                                <td className="action-control">
                                                                    <button role="button" className="delete">
                                                                        <i className="fa fa-trash bg-color-1" aria-hidden="true"></i>
                                                                    </button>
                                                                    <button role="button" className="view">
                                                                        <i className="fa fa-play-circle bg-color-1" aria-hidden="true"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            // <div className="op-pro-parant" key={index}>
                                                            //     <span className="delete z-2">
                                                            //         <button title="delete" className="del-ico">
                                                            //             <i className="fa fa-trash-alt"></i>
                                                            //         </button>
                                                            //     </span>
                                                            //     <span
                                                            //         onClick={() => localStorage.setItem("queue_name", queue.queue_name)}
                                                            //         key={index} className="card">
                                                            //         <span className="count">
                                                            //             {queue.files}
                                                            //         </span>
                                                            //         <div className="q-name">
                                                            //             {queue.queue_name}
                                                            //         </div>
                                                            //         <div className="q-des">
                                                            //             {queue.description}
                                                            //         </div>
                                                            //     </span>
                                                            // </div>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        }
                                        {/* <nav className="navbar navbar-expand-md bg-dark navbar-dark l-3 z-1" id="nav-tab" role="tablist" >
                                            <ul className="navbar-nav nav">
                                                <li className="nav-item ">
                                                    <a
                                                        className="nav-link active"
                                                        id="nav-home-tab"
                                                        data-toggle="tab"
                                                        href="#import_correct"
                                                        role="tab"
                                                        aria-controls="nav-home"
                                                        aria-selected="true"
                                                    >
                                                        Import Files  <span className="badge badge-success"> {this.state.filesList.length} </span>
                                                    </a>
                                                </li>

                                                <li className="nav-item ">
                                                    <a
                                                        className="nav-link"
                                                        id="nav-profile-tab"
                                                        data-toggle="tab"
                                                        href="#import_errors"
                                                        role="tab"
                                                        aria-controls="nav-profile"
                                                        aria-selected="false"
                                                    >
                                                        Errors <span className="badge badge-danger"> {this.state.errorList.length} </span>
                                                    </a>
                                                </li>
                                            </ul>
                                </nav> */}
                                        {/* <div className="tab-content pd-2" id="nav-tabContent">
                                            <div className="tab-pane fade show active" id="import_correct" role="tabpanel" aria-labelledby="nav-home-tab" >

                                                <div className="table-responsive wrap-batch-files">
                                                    {!this.state.loadingQueueFiles ?
                                                        <>
                                                            {this.state.filesList.length > 0 ?
                                                                <table className="table table-bordered table-dark">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className="s-no">#</th>
                                                                            <th scope="col" className="f-name">File name</th>
                                                                            <th scope="col" className="date" onClick={this.handleSort}  >Date</th>
                                                                            <th scope="col" className="predict">Predicted</th>
                                                                            <th scope="col" className="Action">Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.filesList.map((file, index) => {
                                                                            const fileName = file.name.split("/");
                                                                            const activeClass = this.state.fileName === fileName ? "active-tr" : "";
                                                                            const NameOfTheFile = fileName.pop();
                                                                            return (
                                                                                <tr className={activeClass} key={index}>
                                                                                    <th scope="row">{index + 1}</th>
                                                                                    <td>{NameOfTheFile}</td>
                                                                                    <td>{moment(file.date, "DD-MM-YYYY").format("DD-MM-YYYY")}</td>
                                                                                    <td className="text-center">{file.status ? <i className={`fa ${file.fontIcon} text-center bg-color-1`} aria-hidden="true"></i> : ""}</td>
                                                                                    <td className="action-control">
                                                                                        {file.status === "true" || file.status === "false" ?
                                                                                            <button role="button" className="view" onClick={() => this.analyseData(file)}>
                                                                                                <i className="fa fa-eye bg-color-1" aria-hidden="true"></i>
                                                                                            </button>
                                                                                            :
                                                                                            <button className="text-muted pointer-events-none">
                                                                                                <i className="fa fa-eye-slash bg-color-1" aria-hidden="true"></i>
                                                                                            </button>
                                                                                        }
                                                                                        <button role="button" className="delete" onClick={() => this.deleteAsset(file)}>
                                                                                            <i className="fa fa-trash bg-color-1" aria-hidden="true"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                                : <p className="text-white text-center mt-3">No Data Available</p>
                                                            }
                                                        </>
                                                        : <Spinner className="mt-3" label="Loading Queue files" size={SpinnerSize.small} />
                                                    }
                                                </div>

                                            </div>

                                            <div className="tab-pane fade" id="import_errors" role="tabpanel" aria-labelledby="nav-profile-tab" >
                                                <div className="table-responsive wrap-batch-files">
                                                    {this.errFileShow()}
                                                </div>
                                            </div>
                                                </div> */}
                                    </section>
                                </div>
                                <div className="col br-r-1 pd-2">
                                    {/* {!this.state.loadingFile && !this.state.imageUri &&
                             <div className="text-center">Select File view</div>
                            } */}
                                    {this.state.loadingFile
                                        ?
                                        <>
                                            {/* <CanvasCommandBar
                                            handleZoomIn={this.handleCanvasZoomIn}
                                            handleZoomOut={this.handleCanvasZoomOut}
                                        /> */}
                                            {this.state.imageUri ?
                                                <>
                                                    <div className="zoom-controls">
                                                        <button type="button" onClick={this.handleCanvasZoomIn}>
                                                            <i data-icon-name="ZoomIn" role="presentation" aria-hidden="true" className="ms-Icon root-37 css-48 ms-Button-icon icon-70"></i>
                                                        </button>
                                                        <button type="button" onClick={this.handleCanvasZoomOut}>

                                                            <i data-icon-name="ZoomOut" role="presentation" aria-hidden="true" className="ms-Icon root-37 css-48 ms-Button-icon icon-70"></i>
                                                        </button>
                                                    </div>
                                                    <div className="page-name"> {this.state.fileName} </div>
                                                    <hr />
                                                    <ImageMap
                                                        initEditorMap={true}
                                                        ref={(ref) => this.imageMap = ref}
                                                        imageUri={this.state.imageUri || ""}
                                                        imageWidth={this.state.imageWidth}
                                                        imageHeight={this.state.imageHeight}
                                                        featureStyler={this.featureStyler}
                                                        onMapReady={this.noOp}
                                                    />
                                                </>
                                                : <div className="canvas-ocr-loading">
                                                    <div className="canvas-ocr-loading-spinner">
                                                        <Spinner size={SpinnerSize.large} label="Loading File..." ariaLive="assertive" labelPosition="right" />
                                                    </div>
                                                </div>
                                            }
                                        </>
                                        :
                                        <div className="batch-run">
                                            <div className="text-uppercase mt-2 text-white">Batch Jobs</div>
                                            <div className="mt-1">
                                                <table className="table table-bordered table-hover table-dark">
                                                    <thead className="text-center">
                                                        <tr>
                                                            <th scope="col" className="s-no">Runtime Information</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td scope="col" className="s-no">Batch run 9 AM</td>
                                                        </tr>
                                                        <tr className="active-tr">
                                                            <td scope="col" className="s-no">Batch run 10 AM</td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="col" className="s-no">Batch run 11 AM</td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="col" className="s-no">Batch run 12 PM</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="col pd-2">
                                    <div className="preview_json">
                                        <div className="batch-run">
                                            <div className="text-uppercase mt-2 text-white">Logs</div>
                                            <div className="mt-1">
                                                <table className="table table-bordered table-hover table-dark">
                                                    <thead className="text-center">
                                                        <tr>
                                                            <th scope="col" className="s-no">Logs Details</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td scope="col" className="s-no">Files read 10,000 </td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="col" className="s-no">Files processed 8,500 </td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="col" className="s-no">Files Skipped 1500
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="col" className="s-no">Files for Image Classification 8,480</td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="col" className="s-no">Files for OCR 8,480</td>
                                                        </tr>
                                                        <tr>
                                                            <td scope="col" className="s-no">
                                                                <span className="logs-css">Files with errors 20</span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="preview_json">
                                        {this.state.analyzeResult &&
                                            <>
                                                <button type="button" className="btn-max-min expand" onClick={() => this.getExpandButton(true)} data-toggle="collapse" data-target="#demo" aria-expanded="true"><i className="fa fa-expand"></i> </button>
                                            </>
                                        }
                                        {this.viewJSONFun()}
                                        {!this.state.loadingJson && !this.state.analyzeResult && !this.state.errorMessage &&
                                            <span>Select file</span>
                                        }
                                        {this.state.errorMessage && this.state.errorMessage
                                            && <p className="text-center mt-5">{this.state.errorMessage}</p>}
                                        {this.state.loadingJson
                                            && <Spinner
                                                label="Loading JSON"
                                                ariaLive="off"
                                                className="loading" size={SpinnerSize.large} />
                                        }

                                    </div> */}
                                </div>
                            </div>
                        </>
                    }
                    <Confirm title="Delete File"
                        ref={this.deleteFileConfirm}
                        message="Are you sure you want to delete this File ?"
                        confirmButtonTheme={getPrimaryRedTheme()}
                        onCancel={this.onDeleteFileCancel}
                        onConfirm={this.onDeleteFile} />
                </LoadingOverlay>
            </>
        );
    }

    /**
     * Expand
     */
    private getExpandButton = (value) => {
        this.setState({ expandString: value });;
    }
    /**
     * srt Zoom In
     */
    private handleCanvasZoomIn = () => {
        this.imageMap.zoomIn();
    }

    private handleCanvasZoomOut = () => {
        this.imageMap.zoomOut();
    }

    private handleZoomReset = () => {
        this.imageMap.resetZoom();
    }
    /**
     * Get Asset
     */
    private getAssetType = (format) => {
        switch (format.toLowerCase()) {
            case "jpg":
            case "jpeg":
            case "png":
            case "bmp":
                return AssetType.Image;
            case "tif":
            case "tiff":
                return AssetType.TIFF;
            case "pdf":
                return AssetType.PDF;
            default:
                return AssetType.Unknown;
        }
    }
    /**
     * Show Preview
     */
    private loadImage = async (asset) => {
        const lastDot = asset.file_name.lastIndexOf(".");
        const ext = asset.file_name.substring(lastDot + 1);
        const assetType = this.getAssetType(ext)
        if (assetType === AssetType.Image) {
            const canvas = await loadImageToCanvas(asset.path);
            this.setState({
                loadingFile: true,
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
            });
        } else if (assetType === AssetType.TIFF) {
            this.setState({ loadingFile: true });
            await this.loadTiffFile(asset);
        } else if (assetType === AssetType.PDF) {
            this.setState({ loadingFile: true });
            await this.loadPdfFile(asset.path);
        }
    }

    private loadTiffFile = async (asset) => {
        const assetArrayBuffer = await HtmlFileReader.getAssetArray(asset);
        const tiffImages = parseTiffData(assetArrayBuffer);
        this.loadTiffPage(tiffImages, this.state.currentPage);
    }

    private loadTiffPage = (tiffImages: any[], pageNumber: number) => {
        const tiffImage = tiffImages[pageNumber - 1];
        const canvas = renderTiffToCanvas(tiffImage);
        this.setState({
            imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
            imageWidth: tiffImage.width,
            imageHeight: tiffImage.height,
            numPages: tiffImages.length,
            currentPage: pageNumber,
            tiffImages,
        });
    }

    private loadPdfFile = async (url) => {
        try {
            const pdf = await pdfjsLib.getDocument({ url, cMapUrl, cMapPacked: true }).promise;
            // Fetch current page
            if (url) {
                await this.loadPdfPage(url, pdf, this.state.currentPage);
            }
        } catch (reason) {
            // PDF loading error
            console.error(reason);
        }
    }

    private loadPdfPage = async (url, pdf, pageNumber) => {
        const page = await pdf.getPage(pageNumber);
        const defaultScale = 2;
        const viewport = page.getViewport({ scale: defaultScale });

        // Prepare canvas using PDF page dimensions
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
            canvasContext: context,
            viewport,
        };
        await page.render(renderContext).promise;
        if (url) {
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
                numPages: pdf.numPages,
                currentPage: pageNumber,
                pdfFile: pdf
            });
        }
    }


    private showPreview = (file: any) => {
        console.log("****--***-----**--");
    }

    /**
     * Get Projects
     */
    private async getProjects(): Promise<any> {
        this.setState({ loadingProjects: true, loaderMessage: "Loading Models" });
        const { projectName } = this.state;
        const resultData = await this.props.userModelActions.loadUserModels();
        const healthQueue = {
            OCR: "OCR",
            accuracy: 1,
            created_date: "2020-06-24 04:04:17.936572",
            hosted: "Hosted",
            labels: [],
            model_id: "86c1a648-c2f0-49cf-a3d9-122a3e0106e3",
           // project_name: "Health-Certificates",
            project_name: "Purchange Orders",
        };
        await this.setState({ projectList: resultData });
        await this.setState((prevState) => ({
            projectList: [...prevState.projectList, healthQueue], loadingProjects: false,
        }));
        if (resultData.length > 0) {
            if (projectName === "Health-queue") {
                this.setState({ projectName: healthQueue.project_name, selectedProject: healthQueue });
            } else {
                const projectValue = resultData.filter((project) => project.project_name === projectName);
                this.setState({ projectName: projectValue[0].project_name, selectedProject: projectValue });
            }
            // if (projectName) {
            //     const projectValue = resultData.filter((project) => project.project_name === projectName);
            //     this.setState({ projectName: projectValue[0].project_name, selectedProject: projectValue[0] });
            //     this.getQueues();
            // }
            // this.setState({ loadingProjects: false, projectList: resultData });
        }
    }

    /**
     * Get Queues
     */

    private async getQueues(): Promise<any> {
        this.setState({ loadingQueues: true, loaderMessage: "Loading Queues" });
        const { projectName, queueName } = this.state;
        const dataEndPoint = await this.props.userOperationsActions.userAllQueues(projectName)
        this.setState({ queuesList: dataEndPoint, loadingQueues: false });
        if (queueName && dataEndPoint.length > 0) {
            const selectedQueue = dataEndPoint.filter((queue) => queue.queue_name === queueName);
            this.setState({ selectedQueue: selectedQueue[0], loadingQueues: false });
            this.getAllFiles();
        } else {
            this.setState({ loadingQueues: false });
        }
    }

    private onChange = async (values) => {
        localStorage.removeItem("queue_name");
        this.setState({ imageUri: null, analyzeResult: null, queueName: "", selectedQueue: null, filesList: [] });
        if (values) {
            await this.setState({ queuesList: [], selectedProject: values, projectName: values.project_name });
            localStorage.setItem("project_name", values.project_name);
            this.getQueues();
        }
    }

    private onQueueChange = async (values) => {
        this.setState({ imageUri: null, analyzeResult: null });
        if (values) {
            await this.setState({ selectedQueue: values, filesList: [], queueName: values.queue_name });
            localStorage.setItem("queue_name", values.queue_name);
            this.getAllFiles();
        }
    }
    /**
     * Get Processed Files
     */
    private getProcessedFiles = () => {
        let headers = accessToken()
        // processedFileEndPoint, LoadUserFilesEndPointBasedOnModel, headers
        const { projectName, queueName } = this.state;
        const endpointURL = processedFileEndPoint(projectName, queueName);
        return ServiceHelper.getWithAutoRetry(endpointURL, { headers });
    }
    /**
     * Get Blob Files
     */
    private getBlobFiles = () => {
        const { projectName, queueName } = this.state;
        const endpointURL = LoadUserFilesEndPointBasedOnModel(projectName, queueName)
        return ServiceHelper.getWithAutoRetry(endpointURL, { headers });
    }
    /**
     * Get All File from both list and process API calls
     */
    private getAllFiles = async () => {
        this.setState({ loadingQueueFiles: true, loadingFile: false, analyzeResult: null, errorList: this.state.errFiles });
        Promise.all([this.getBlobFiles(), this.getProcessedFiles()]).then((values) => {
            const azureData = values[0].data;
            const processedFiles = values[1].data;
            this.mapFilesList(azureData, processedFiles);
        }).catch((err) => {
            this.setState({ loadingQueueFiles: false });
            toast.error("Some thing went wrong.", { position: toast.POSITION.TOP_CENTER });
        });
    }

    /**
     * Map FilesList
     */
    private mapFilesList = (azureData, processedFiles) => {
        const filesList = [];
        if (azureData.length > 0) {
            azureData.filter((data) => {
                const objectData = data;
                const fileName = data.name.split("/");
                const NameOfTheFile = fileName.pop();
                const temp = processedFiles.length > 0 && processedFiles.find((element) => element.file_name === NameOfTheFile);
                if (temp && temp.file_name === NameOfTheFile) {
                    objectData.file_name = temp.file_name;
                    objectData.status = temp.dcapResults && temp.dcapResults.status;
                    objectData.fontIcon = temp.dcapResults && temp.dcapResults.status === "true" ? "fa-check" : "fa-times";
                    objectData.result = temp.result;
                } else {
                    objectData.file_name = NameOfTheFile;
                    objectData.status = null;
                    objectData.result = null;
                }
                filesList.push(objectData);
            });
        }
        this.setState({ loadingQueueFiles: false, filesList });
    }

    private axiosPromise = (URL: string, formData) => {
        let headers = accessToken();
        return axios(URL, { method: "POST", data: formData, headers });
    }

    private getFileNameWithExt(file) {
        const { fileNames, projectName, queueName } = this.state;
        const name = file.name;
        let queueNameString = queueName;
        if (queueNameString.includes(" ")) {
            queueNameString = queueNameString.replace(/ /g, "-");
        }
        if (fileNames.indexOf(name) === -1) {
            const fileData = {};
            fileData["file"] = file;
            fileData["filename"] = name;
            fileNames.push(file["name"]);
            const formData = new FormData();
            formData.append("name", file);
            const URL = fileUploadEndPoint(projectName, file.name, queueName, "na","na");
            let d = this.axiosPromise(URL, formData).then(data => {
                if (data.data.status != "true" && data.status != 200) {
                    let errObj = {
                        "filename": name
                    }
                    this.state.errFiles.push(errObj)
                }
            }).catch(err => {
                let errObj = {
                    "filename": name
                }
                this.state.errFiles.push(errObj)
            })
            // console.log(this.axiosPromise(URL, formData), "  >>>>this.axiosPromise(URL, formData);")
            return this.axiosPromise(URL, formData);
        } else {
            toast.success(`${file["name"]} file is exists`, { position: toast.POSITION.TOP_CENTER });
        }
    }

    private onChangeHandler = async (event) => {
        event.persist();
        const { queueName } = this.state;
        const tempArray = [];
        let lastFile = false;
        // console.log(event.target.files, " event.target.files")
        if (event.target.files.length > 0) {
            const arrFiles = await Array.from(event.target.files);
            arrFiles.forEach(async (file, index) => {
                tempArray.push(this.getFileNameWithExt(file));
                if (index === arrFiles.length - 1) {
                    return lastFile = true;
                }
            });
        }
        if (lastFile && queueName) {
            this.setState({ loadingQueueFiles: true, loaderMessage: "Uploading Files" });
            Promise.all(tempArray).then((values) => {
                // this.setState({ loadingProjects: false });
                this.getAllFiles();
            }).catch((err) => {
                this.setState({ loadingQueueFiles: false });
                toast.error("Some thing went wrong.", { position: toast.POSITION.TOP_CENTER });
            });
        }
    }

    /**
     * Download JSON export file
     * 
     */

    private downloadFile = async () => {
        const parts = this.state.fileName.split("/");
        const fileName = parts.pop() || parts.pop();
        const nameFile = fileName.replace(/(.*)\.[^.]+$/, "$1");
        const myData = this.state.analyzeResult
        const json = JSON.stringify(myData);
        const blob = new Blob([json], { type: 'application/json' });
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = nameFile + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private editableJSON = () => {
        this.setState({ isEditJson: true })
    }

    private handleSort = () => {
        if (this.state.isBool == false) {
            let sortData = this.state.filesList.sort((d1, d2) => new Date(d1.date).getTime() - new Date(d2.date).getTime());
            this.setState({ filesList: sortData })
        } else {
            let sortData = this.state.filesList.sort((d1, d2) => new Date(d1.date).getTime() - new Date(d2.date).getTime());
            sortData = sortData.reverse()
            this.setState({ filesList: sortData })
        }
    }

    /** Editable JSON View */
    private editableJSONView = () => {
        this.setState({ loadingQueues: true, loaderMessage: "Loading ..." })
        if (this.state.changedJSON[0] != undefined) {
            // this.setState({ loadingJson: true });
            const projectName = this.state.projectName;
            this.props.userOperationsActions.dataRevisionEditJson(this.state.changedJSON[0], projectName).then((editJson) => {
                this.setState({ isEditJson: false, loadingQueues: false, changedJSON: [] });
                toast.success(`success`, { position: toast.POSITION.TOP_CENTER });
            }).catch((err) => {
                toast.error(`Some thing went wrong.`, { position: toast.POSITION.TOP_CENTER });
                this.setState({ isEditJson: false, loadingQueues: false })
                console.log(err);
            });
        } else {
            this.setState({ isEditJson: false, loadingQueues: false })
            toast.warn("There No chnages", { position: toast.POSITION.TOP_CENTER });
        }
    }

    private cancelJsonButtonClick = () => {
        this.setState({ isEditJson: false });
    }

    /**
     * Batch Process Queue
     */
    private processBatch = async () => {

        const { queueName, projectName, selectedProject, selectedQueue } = this.state;
        const processFlagObj = {
            selectedProject,
            selectedQueue,
        }
        localStorage.setItem("processingBatch", JSON.stringify(processFlagObj));
        if (queueName && projectName) {
            this.setState({ batchProcessFlag: true, loaderMessage: "Started batch processing" });
            let queueNameString = queueName;
            if (queueNameString.includes(" ")) {
                queueNameString = queueNameString.replace(/ /g, "-");
            }
            this.props.userOperationsActions.batchPredictionForAllBlobs(projectName, queueName).then((predicteddata) => {
                this.getAllFiles();
                this.setState({ batchProcessFlag: false });
            }).catch((err) => {
                this.setState({ batchProcessFlag: false });
                console.log(err);
            });
        } else {
            toast.warn("Please Select Project/Queue Fields", { position: toast.POSITION.TOP_CENTER });
        }
    }

    /** delete file */
    private deleteAsset = (file: any) => {
        this.deleteFileConfirm.current.open(file);
    }

    private onDeleteFileCancel = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }

    private onDeleteFile = async (file: any) => {
        this.setState({ loadingQueueFiles: true, loaderMessage: "Deleting  File" });
        const { queueName, projectName } = this.state;
        let str = queueName;
        if (str.includes(" ")) {
            str = queueName.replace(/ /g, "-");
        }
        const resultData = await this.props.userOperationsActions.deleteFileFromQueue(projectName, queueName, file.file_name)
        if (resultData == 'Blobs deleted successfully!') {
            const newArray = [...this.state.filesList];
            const index = await newArray.indexOf(file);
            if (index > -1) {
                newArray.splice(index, 1);
            }
            if (this.state.fileName === file.file_name) {
                this.setState({ loadingFile: false, imageUri: null, analyzeResult: null });
            }
            this.setState({ filesList: newArray, loadingQueueFiles: false });
        } else {
            this.setState({ loadingQueueFiles: false });
            //     console.log(err);
        }
    }

    /** Analyse data from azure */
    private analyseData = async (file: any) => {
        this.setState({ imageUri: null, fileName: file.file_name });
        await this.loadImage(file);
        const { projectName, queueName } = this.state;
        this.setState({ analyzeResult: null, loadingJson: true, errorMessage: null });
        this.props.userOperationsActions.analyseFileJsonResult(projectName, queueName, file.file_name).then((analysedData: any) => {
            if (analysedData.data) {
                this.setState({ analyzeResult: analysedData.data });
            } else if (analysedData.data.error) {
                const data2 = analysedData.data.error.substr(analysedData.data.error.indexOf(":") + 1); // "tocirah sneab"
                const errorJson = JSON.parse(data2);
                this.setState({ errorMessage: "The input data is not a valid image or password protected" });
            }
            this.setState({ loadingJson: false });
        }).catch((err) => {
            this.setState({ loadingQueueFiles: false });
        });
    }
}
